// NOTE: chatGPT generated
export default function isValidCssColor(value) {
  // CSS variables: var(--my-color)
  if (/^var\(--[\w-]+\)$/.test(value.trim())) {
    return true;
  }

  // Fast check with CSS.supports (if available)
  if (
    typeof CSS !== "undefined" &&
    CSS.supports &&
    CSS.supports("color", value)
  ) {
    return true;
  }

  // Check through creating a DOM element (in case CSS.supports is not supported)
  const option = new Option();
  option.style.color = "";
  option.style.color = value.trim();

  return option.style.color !== "";
}
